import repository from '@/utils/repository';

const resource = '/move/CUS_Client003';

export default {
    storeSupplier: (data) => {
        return repository.post(`${resource}`, {
            ...data
        });
    },
    searchItem: (data) => {
        return repository.post(`${resource}/search`, {
            ...data
        });
    },
    getAreaInfo: (data) => {
        return repository.post(`move/postCommonAreaInfo`, {
            ...data
        });
    }
};
